// The neutral full-screen layer for the app switcher (Tool Plan §3 rule 7,
// D-67, IR-08; I-1a batch 5). Plain background, no words, no icon: the
// snapshot shows nothing of the app. Always in the page; the class on <html>
// (useAppSwitcherCover) shows it and hides the page, with no render in between.
// Hidden from screen readers; a tap removes it.

export function AppSwitcherCover({ onTap }: { readonly onTap: () => void }): React.JSX.Element {
  return <div className="cover" aria-hidden="true" data-testid="app-switcher-cover" onPointerDown={onTap} />
}
